const env = process.env.NODE_ENV || "development";

const apiEnvironment = {
  development: {
    api: "https://ytuongqhbaisonghong-api.cgis.asia/",
    DomainUserSite:"http://localhost:3000",
    DomainAdminSite:"http://localhost:3001",
    DoMainNameGeoServer:"https://geo.cgis.asia/geoserver/wfs",
    DoMainNameGeoServerWMS:"https://geo.cgis.asia/geoserver/wms",
    DomainName:"",
    IframeUrl: "https://qhbaidasonghong.datvangvietnam.net/"
  },
  production: {
    api: "https://ytuongqhbaisonghong-api.cgis.asia/",
    DomainUserSite:"https://ytuongqhbaisonghong.cgis.asia",
    DomainAdminSite:"https://ytuongqhbaisonghong-admin.cgis.asia",
    DoMainNameGeoServer:"https://geo.cgis.asia/geoserver/wfs",
    DoMainNameGeoServerWMS:"https://geo.cgis.asia/geoserver/wms",
    DomainName:"cgis.asia",
    IframeUrl: "https://qhbaidasonghong.datvangvietnam.net/"
  },
};

module.exports = apiEnvironment[env];
